import React, { useEffect } from "react";
import { Spin } from "antd";
import { resolveNewFrontendHref } from "../../../app/navigation/new-frontend-href";

/**
 * 旧总表地址一律进新台账。合同项必须走并列地址
 * /contract-management/supplier-contract-items，不能写在这条下面。
 */
export default function SupplierContractsRedirect() {
    useEffect(() => {
        const { pathname, search } = window.location;
        const marker = "/contract-management/supplier-contracts";
        const start = pathname.indexOf(marker);
        const suffix = start >= 0 ? pathname.slice(start) : marker;
        window.location.replace(resolveNewFrontendHref(`${suffix}${search || ""}`));
    }, []);

    return (
        <div className="page-container">
            <div style={{ textAlign: "center", padding: 48 }}>
                <Spin />
                <div style={{ marginTop: 12 }}>正在打开新的供应商合同总台账…</div>
            </div>
        </div>
    );
}
